import React from 'react';
import style from './ProductOverviewHelper.module.scss';
import { ArrowRightOutlined } from '@ant-design/icons';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import COButton from '../COButton';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import COPopover from '../COPopover';
import { BadgePlacements } from 'enums/COAlertModal';
import COBadge from '../COBadge';
import { ReactComponent as AlertIcon } from 'assets/icons/Info.svg';
import { BadgeText } from 'enums/ProductOverviewHelperEnums';
import moment from 'moment';
import defaultProductImage from 'assets/images/product_img1.png';
import formatNumberWithCommas from 'shared/utils/formatNumberWithComma';

interface ProductOverviewHelperProps {
  temperatureControl: string | undefined;
  grossWeight: number | undefined;
  reportingPeriodUnits: number | undefined;
  percentagePFGoods: number | undefined;
  reportingPeriod: string | undefined;
  unit: string | undefined;
  productName: string | undefined;
  brandName: string | undefined;
  netWeight: number | undefined;
  b2b: number | undefined | null;
  b2c: number | undefined | null;
  productImage: string | undefined;
}
const ProductOverviewHelper: React.FC<ProductOverviewHelperProps> = ({
  temperatureControl,
  grossWeight,
  reportingPeriodUnits,
  percentagePFGoods,
  reportingPeriod,
  unit,
  productName,
  brandName,
  netWeight,
  b2b,
  b2c,
  productImage,
}: ProductOverviewHelperProps) => {
  const newReportingPeriod = `${moment(
    reportingPeriod?.split('-')[0],
    'MM/YYYY'
  ).format('MMM YYYY')}- ${moment(
    reportingPeriod?.split('-')[1],
    'MM/YYYY'
  ).format('MMM YYYY')}`;

  const data = [
    {
      distributor: 'Product gross weight',
      value: grossWeight,
      unit: 'g',
    },
    {
      distributor: 'Temperature control',
      value: temperatureControl,
    },
    {
      distributor: 'Reporting period production (units)',
      value: reportingPeriodUnits,
    },
    {
      distributor: 'Percentage of processing facility cost of goods sold',
      value: percentagePFGoods,
      unit: '%',
    },
    {
      distributor: 'Reporting period',
      value: newReportingPeriod,
    },
  ];
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const handleNavigation = () => {
    id && navigate(generatePath(AppRoutes.PRODUCT_DASHBOARD, { id }));
  };

  return (
    <div className={style.overviewContainer}>
      <div className={style.topContainer}>
        <div className={style.imageContainer}>
          <img
            src={productImage ?? defaultProductImage}
            alt={productName}
            className={style.productImage}
          />
        </div>
        <div className={style.productNameContainer}>
          <h3>{productName}</h3>
          <p>
            {netWeight} {unit}
          </p>
          <p className={style.brandName}>{brandName}</p>
          <div className={style.redirectionButton}>
            <COButton text onClick={handleNavigation}>
              Product Dashboard <ArrowRightOutlined />
            </COButton>
          </div>
        </div>
      </div>
      <div className={style.labelsContainer}>
        {data.map(item => {
          return (
            <div className={style.labelContainer}>
              <div className={style.distributorContainer}>
                <h3>{item.distributor}</h3>
              </div>
              <div className={style.valueContainer}>
                <p>
                  <span className={style.value}>{item.value}</span>
                  <span className={style.unitText}> {item.unit}</span>
                </p>
              </div>
            </div>
          );
        })}
      </div>
      <div className={style.avgContainer}>
        <div className={style.itemContainer}>
          <div>
            <h2>B2B</h2>
          </div>
          <div className={style.carbonValueContainer}>
            <h3 className={style.carbonValue}>
              {formatNumberWithCommas(b2b)} kgCO<sub>2</sub>e
            </h3>
          </div>
          <div className={style.toolTip}>
            <COPopover
              placement={BadgePlacements.TR}
              text={BadgeText.ICON1_TEXT}>
              <COBadge>
                <AlertIcon className={style.infoIcon} />
              </COBadge>
            </COPopover>
          </div>
        </div>
        <div className={style.itemContainer}>
          <div>
            <h2>B2C</h2>
          </div>
          <div className={style.carbonValueContainer}>
            <h3 className={style.carbonValue}>
              {formatNumberWithCommas(b2c)} kgCO<sub>2</sub>e
            </h3>
          </div>
          <div className={style.toolTip}>
            <COPopover
              placement={BadgePlacements.TR}
              text={BadgeText.ICON2_TEXT}>
              <COBadge>
                <AlertIcon className={style.infoIcon} />
              </COBadge>
            </COPopover>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductOverviewHelper;
